var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['block-inner', _vm.blockStyle]},[(_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",staticClass:"style-icon",attrs:{"width":32,"height":32}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.blockContent)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }